/* tslint:disable */
/* auto-generated angular directive proxies */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, NgZone } from '@angular/core';
import { ProxyCmp, proxyOutputs } from './angular-component-lib/utils';

import { Components } from '@bkkr/core';




export declare interface BkkrAccordion extends Components.BkkrAccordion {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['disabled', 'readonly', 'toggleIcon', 'toggleIconSlot', 'value']
})
@Component({
  selector: 'bkkr-accordion',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['disabled', 'readonly', 'toggleIcon', 'toggleIconSlot', 'value']
})
export class BkkrAccordion {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}

import type { AccordionGroupChangeEventDetail as IAccordionGroupAccordionGroupChangeEventDetail } from '@bkkr/core';
export declare interface BkkrAccordionGroup extends Components.BkkrAccordionGroup {
  /**
   * Emitted when the value property has changed. 
   */
  bkkrChange: EventEmitter<CustomEvent<IAccordionGroupAccordionGroupChangeEventDetail>>;

}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['animated', 'disabled', 'expand', 'multiple', 'readonly', 'value']
})
@Component({
  selector: 'bkkr-accordion-group',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['animated', 'disabled', 'expand', 'multiple', 'readonly', 'value']
})
export class BkkrAccordionGroup {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['bkkrChange']);
  }
}


export declare interface BkkrBackdrop extends Components.BkkrBackdrop {
  /**
   * Emitted when the backdrop is tapped. 
   */
  bkkrBackdropTap: EventEmitter<CustomEvent<void>>;

}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['stopPropagation', 'tappable', 'visible']
})
@Component({
  selector: 'bkkr-backdrop',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['stopPropagation', 'tappable', 'visible']
})
export class BkkrBackdrop {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['bkkrBackdropTap']);
  }
}


export declare interface BkkrBadge extends Components.BkkrBadge {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['color']
})
@Component({
  selector: 'bkkr-badge',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['color']
})
export class BkkrBadge {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface BkkrBreadcrumb extends Components.BkkrBreadcrumb {
  /**
   * Emitted when the breadcrumb has focus. 
   */
  bkkrFocus: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the breadcrumb loses focus. 
   */
  bkkrBlur: EventEmitter<CustomEvent<void>>;

}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['active', 'color', 'disabled', 'download', 'href', 'rel', 'routerAnimation', 'routerDirection', 'separator', 'target']
})
@Component({
  selector: 'bkkr-breadcrumb',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['active', 'color', 'disabled', 'download', 'href', 'rel', 'routerAnimation', 'routerDirection', 'separator', 'target']
})
export class BkkrBreadcrumb {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['bkkrFocus', 'bkkrBlur']);
  }
}

import type { BreadcrumbCollapsedClickEventDetail as IBreadcrumbsBreadcrumbCollapsedClickEventDetail } from '@bkkr/core';
export declare interface BkkrBreadcrumbs extends Components.BkkrBreadcrumbs {
  /**
   * Emitted when the collapsed indicator is clicked on. 
   */
  bkkrCollapsedClick: EventEmitter<CustomEvent<IBreadcrumbsBreadcrumbCollapsedClickEventDetail>>;

}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['color', 'itemsAfterCollapse', 'itemsBeforeCollapse', 'maxItems']
})
@Component({
  selector: 'bkkr-breadcrumbs',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['color', 'itemsAfterCollapse', 'itemsBeforeCollapse', 'maxItems']
})
export class BkkrBreadcrumbs {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['bkkrCollapsedClick']);
  }
}


export declare interface BkkrButton extends Components.BkkrButton {
  /**
   * Emitted when the button has focus. 
   */
  bkkrFocus: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the button loses focus. 
   */
  bkkrBlur: EventEmitter<CustomEvent<void>>;

}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['color', 'disabled', 'download', 'expand', 'fill', 'form', 'href', 'rel', 'routerDirection', 'shape', 'size', 'target', 'type']
})
@Component({
  selector: 'bkkr-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['color', 'disabled', 'download', 'expand', 'fill', 'form', 'href', 'rel', 'routerDirection', 'shape', 'size', 'target', 'type']
})
export class BkkrButton {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['bkkrFocus', 'bkkrBlur']);
  }
}


export declare interface BkkrCard extends Components.BkkrCard {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['button', 'color', 'disabled', 'download', 'fill', 'href', 'rel', 'routerDirection', 'target', 'type']
})
@Component({
  selector: 'bkkr-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['button', 'color', 'disabled', 'download', 'fill', 'href', 'rel', 'routerDirection', 'target', 'type']
})
export class BkkrCard {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface BkkrCardContent extends Components.BkkrCardContent {}

@ProxyCmp({
  defineCustomElementFn: undefined
})
@Component({
  selector: 'bkkr-card-content',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>'
})
export class BkkrCardContent {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface BkkrCardHeader extends Components.BkkrCardHeader {}

@ProxyCmp({
  defineCustomElementFn: undefined
})
@Component({
  selector: 'bkkr-card-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>'
})
export class BkkrCardHeader {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}

import type { CheckboxChangeEventDetail as ICheckboxCheckboxChangeEventDetail } from '@bkkr/core';
export declare interface BkkrCheckbox extends Components.BkkrCheckbox {
  /**
   * Emitted when the checked property has changed. 
   */
  bkkrChange: EventEmitter<CustomEvent<ICheckboxCheckboxChangeEventDetail>>;
  /**
   * Emitted when the checkbox has focus. 
   */
  bkkrFocus: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the checkbox loses focus. 
   */
  bkkrBlur: EventEmitter<CustomEvent<void>>;

}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['checked', 'color', 'disabled', 'indeterminate', 'name', 'value']
})
@Component({
  selector: 'bkkr-checkbox',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['checked', 'color', 'disabled', 'indeterminate', 'name', 'value']
})
export class BkkrCheckbox {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['bkkrChange', 'bkkrFocus', 'bkkrBlur']);
  }
}


export declare interface BkkrCol extends Components.BkkrCol {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['order', 'orderLg', 'orderMd', 'orderSm', 'orderXl', 'orderXs', 'orderXxl', 'size', 'sizeLg', 'sizeMd', 'sizeSm', 'sizeXl', 'sizeXs', 'sizeXxl']
})
@Component({
  selector: 'bkkr-col',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['order', 'orderLg', 'orderMd', 'orderSm', 'orderXl', 'orderXs', 'orderXxl', 'size', 'sizeLg', 'sizeMd', 'sizeSm', 'sizeXl', 'sizeXs', 'sizeXxl']
})
export class BkkrCol {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface BkkrContainer extends Components.BkkrContainer {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['color', 'fluid']
})
@Component({
  selector: 'bkkr-container',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['color', 'fluid']
})
export class BkkrContainer {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}

import type { ScrollBaseDetail as IContentScrollBaseDetail } from '@bkkr/core';
import type { ScrollDetail as IContentScrollDetail } from '@bkkr/core';
export declare interface BkkrContent extends Components.BkkrContent {
  /**
   * Emitted when the scroll has started. 
   */
  bkkrScrollStart: EventEmitter<CustomEvent<IContentScrollBaseDetail>>;
  /**
   * Emitted while scrolling. This event is disabled by default.
Look at the property: `scrollEvents` 
   */
  bkkrScroll: EventEmitter<CustomEvent<IContentScrollDetail>>;
  /**
   * Emitted when the scroll has ended. 
   */
  bkkrScrollEnd: EventEmitter<CustomEvent<IContentScrollBaseDetail>>;

}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['color', 'fullscreen', 'scrollEvents', 'scrollX', 'scrollY'],
  methods: ['getScrollElement', 'scrollToTop', 'scrollToBottom', 'scrollByPoint', 'scrollToPoint']
})
@Component({
  selector: 'bkkr-content',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['color', 'fullscreen', 'scrollEvents', 'scrollX', 'scrollY']
})
export class BkkrContent {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['bkkrScrollStart', 'bkkrScroll', 'bkkrScrollEnd']);
  }
}

import type { DatetimeChangeEventDetail as IDatetimeDatetimeChangeEventDetail } from '@bkkr/core';
export declare interface BkkrDatetime extends Components.BkkrDatetime {
  /**
   * Emitted when the selection is opened. 
   */
  bkkrOpen: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the selection is cancelled. 
   */
  bkkrCancel: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when a keyboard datetime occurred. 
   */
  bkkrInput: EventEmitter<CustomEvent<KeyboardEvent>>;
  /**
   * Emitted when the value has changed. 
   */
  bkkrChange: EventEmitter<CustomEvent<IDatetimeDatetimeChangeEventDetail>>;
  /**
   * Emitted when the datetime loses focus. 
   */
  bkkrBlur: EventEmitter<CustomEvent<FocusEvent>>;
  /**
   * Emitted when the datetime has focus. 
   */
  bkkrFocus: EventEmitter<CustomEvent<FocusEvent>>;

}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['autofocus', 'color', 'dayNames', 'dayShortNames', 'disabled', 'displayFormat', 'enterkeyhint', 'inputmode', 'interfaceOptions', 'max', 'min', 'monthNames', 'monthShortNames', 'name', 'picker', 'placeholder', 'readonly', 'required', 'value'],
  methods: ['setFocus', 'getDatetimeElement', 'open']
})
@Component({
  selector: 'bkkr-datetime',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['autofocus', 'color', 'dayNames', 'dayShortNames', 'disabled', 'displayFormat', 'enterkeyhint', 'inputmode', 'interfaceOptions', 'max', 'min', 'monthNames', 'monthShortNames', 'name', 'picker', 'placeholder', 'readonly', 'required', 'value']
})
export class BkkrDatetime {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['bkkrOpen', 'bkkrCancel', 'bkkrInput', 'bkkrChange', 'bkkrBlur', 'bkkrFocus']);
  }
}


export declare interface BkkrFab extends Components.BkkrFab {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['edge', 'horizontal', 'vertical']
})
@Component({
  selector: 'bkkr-fab',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['edge', 'horizontal', 'vertical']
})
export class BkkrFab {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface BkkrFabButton extends Components.BkkrFabButton {
  /**
   * Emitted when the button has focus. 
   */
  bkkrFocus: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the button loses focus. 
   */
  bkkrBlur: EventEmitter<CustomEvent<void>>;

}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['color', 'disabled', 'download', 'href', 'rel', 'routerDirection', 'shape', 'size', 'target', 'type']
})
@Component({
  selector: 'bkkr-fab-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['color', 'disabled', 'download', 'href', 'rel', 'routerDirection', 'shape', 'size', 'target', 'type']
})
export class BkkrFabButton {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['bkkrFocus', 'bkkrBlur']);
  }
}


export declare interface BkkrFooter extends Components.BkkrFooter {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['collapse', 'color', 'position']
})
@Component({
  selector: 'bkkr-footer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['collapse', 'color', 'position']
})
export class BkkrFooter {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface BkkrGrid extends Components.BkkrGrid {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['size', 'sizeLg', 'sizeMd', 'sizeSm', 'sizeXl', 'sizeXs', 'sizeXxl']
})
@Component({
  selector: 'bkkr-grid',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['size', 'sizeLg', 'sizeMd', 'sizeSm', 'sizeXl', 'sizeXs', 'sizeXxl']
})
export class BkkrGrid {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface BkkrHeader extends Components.BkkrHeader {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['collapse', 'color']
})
@Component({
  selector: 'bkkr-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['collapse', 'color']
})
export class BkkrHeader {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface BkkrIcon extends Components.BkkrIcon {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['color', 'flipRtl', 'icon', 'lazy', 'name', 'sanitize', 'size', 'src', 'type']
})
@Component({
  selector: 'bkkr-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['color', 'flipRtl', 'icon', 'lazy', 'name', 'sanitize', 'size', 'src', 'type']
})
export class BkkrIcon {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface BkkrImg extends Components.BkkrImg {
  /**
   * Emitted when the img src has been set 
   */
  bkkrImgWillLoad: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the image has finished loading 
   */
  bkkrImgDidLoad: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the img fails to load 
   */
  bkkrError: EventEmitter<CustomEvent<void>>;

}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['alt', 'animated', 'drag', 'locked', 'src']
})
@Component({
  selector: 'bkkr-img',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['alt', 'animated', 'drag', 'locked', 'src']
})
export class BkkrImg {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['bkkrImgWillLoad', 'bkkrImgDidLoad', 'bkkrError']);
  }
}


export declare interface BkkrInfiniteScroll extends Components.BkkrInfiniteScroll {
  /**
   * Emitted when the scroll reaches
the threshold distance, or stepper have changed. From within your infinite handler,
you must call the infinite scroll's `complete()` method when
your async operation has completed. 
   */
  bkkrInfinite: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when page size have changed. 
   */
  bkkrPageSizeChanged: EventEmitter<CustomEvent<void>>;

}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['animated', 'buttonText', 'disabled', 'href', 'infinite', 'items', 'length', 'loadingText', 'page', 'position', 'spinner', 'threshold', 'toolbar'],
  methods: ['complete']
})
@Component({
  selector: 'bkkr-infinite-scroll',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['animated', 'buttonText', 'disabled', 'href', 'infinite', 'items', 'length', 'loadingText', 'page', 'position', 'spinner', 'threshold', 'toolbar']
})
export class BkkrInfiniteScroll {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['bkkrInfinite', 'bkkrPageSizeChanged']);
  }
}

import type { InputChangeEventDetail as IInputInputChangeEventDetail } from '@bkkr/core';
export declare interface BkkrInput extends Components.BkkrInput {
  /**
   * Emitted when a keyboard input occurred. 
   */
  bkkrInput: EventEmitter<CustomEvent<InputEvent>>;
  /**
   * Emitted when the value has changed. 
   */
  bkkrChange: EventEmitter<CustomEvent<IInputInputChangeEventDetail>>;
  /**
   * Emitted when the input loses focus. 
   */
  bkkrBlur: EventEmitter<CustomEvent<FocusEvent>>;
  /**
   * Emitted when the input has focus. 
   */
  bkkrFocus: EventEmitter<CustomEvent<FocusEvent>>;

}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['accept', 'autocapitalize', 'autocomplete', 'autocorrect', 'autofocus', 'clearInput', 'clearOnEdit', 'color', 'debounce', 'disabled', 'enterkeyhint', 'inputmode', 'max', 'maxlength', 'min', 'minlength', 'multiple', 'name', 'pattern', 'placeholder', 'readonly', 'required', 'size', 'spellcheck', 'step', 'type', 'value'],
  methods: ['setFocus', 'getInputElement']
})
@Component({
  selector: 'bkkr-input',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['accept', 'autocapitalize', 'autocomplete', 'autocorrect', 'autofocus', 'clearInput', 'clearOnEdit', 'color', 'debounce', 'disabled', 'enterkeyhint', 'inputmode', 'max', 'maxlength', 'min', 'minlength', 'multiple', 'name', 'pattern', 'placeholder', 'readonly', 'required', 'size', 'spellcheck', 'step', 'type', 'value']
})
export class BkkrInput {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['bkkrInput', 'bkkrChange', 'bkkrBlur', 'bkkrFocus']);
  }
}


export declare interface BkkrItem extends Components.BkkrItem {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['button', 'color', 'counter', 'counterFormatter', 'detail', 'detailIcon', 'disabled', 'download', 'fill', 'href', 'lines', 'rel', 'routerDirection', 'shape', 'target', 'type']
})
@Component({
  selector: 'bkkr-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['button', 'color', 'counter', 'counterFormatter', 'detail', 'detailIcon', 'disabled', 'download', 'fill', 'href', 'lines', 'rel', 'routerDirection', 'shape', 'target', 'type']
})
export class BkkrItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface BkkrLabel extends Components.BkkrLabel {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['color', 'position']
})
@Component({
  selector: 'bkkr-label',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['color', 'position']
})
export class BkkrLabel {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface BkkrList extends Components.BkkrList {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['inset', 'lines']
})
@Component({
  selector: 'bkkr-list',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['inset', 'lines']
})
export class BkkrList {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface BkkrListHeader extends Components.BkkrListHeader {}

@ProxyCmp({
  defineCustomElementFn: undefined
})
@Component({
  selector: 'bkkr-list-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>'
})
export class BkkrListHeader {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface BkkrMenu extends Components.BkkrMenu {
  /**
   * Emitted when the menu is about to be opened. 
   */
  bkkrWillOpen: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the menu is about to be closed. 
   */
  bkkrWillClose: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the menu is open. 
   */
  bkkrDidOpen: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the menu is closed. 
   */
  bkkrDidClose: EventEmitter<CustomEvent<void>>;

}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['contentId', 'disabled', 'fullscreen', 'maxEdgeStart', 'menuId', 'side', 'swipeGesture', 'type'],
  methods: ['isOpen', 'isActive', 'open', 'close', 'toggle', 'setOpen']
})
@Component({
  selector: 'bkkr-menu',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['contentId', 'disabled', 'fullscreen', 'maxEdgeStart', 'menuId', 'side', 'swipeGesture', 'type']
})
export class BkkrMenu {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['bkkrWillOpen', 'bkkrWillClose', 'bkkrDidOpen', 'bkkrDidClose']);
  }
}


export declare interface BkkrMenuToggle extends Components.BkkrMenuToggle {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['autoHide', 'menu']
})
@Component({
  selector: 'bkkr-menu-toggle',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['autoHide', 'menu']
})
export class BkkrMenuToggle {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface BkkrNav extends Components.BkkrNav {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['disabled', 'download', 'href', 'layout', 'nav', 'rel', 'selected', 'target']
})
@Component({
  selector: 'bkkr-nav',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['disabled', 'download', 'href', 'layout', 'nav', 'rel', 'selected', 'target']
})
export class BkkrNav {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface BkkrNavs extends Components.BkkrNavs {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['color', 'selectedNav']
})
@Component({
  selector: 'bkkr-navs',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['color', 'selectedNav']
})
export class BkkrNavs {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface BkkrNote extends Components.BkkrNote {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['animated', 'color']
})
@Component({
  selector: 'bkkr-note',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['animated', 'color']
})
export class BkkrNote {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface BkkrPaginator extends Components.BkkrPaginator {
  /**
   * Emitted when the stepper have changed. From within your paginator handler,
you must call the paginator's `complete()` method when
your async operation has completed. 
   */
  bkkrPaginator: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when page size have changed. 
   */
  bkkrPageSizeChanged: EventEmitter<CustomEvent<void>>;

}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['animated', 'arrowIcon', 'changeLength', 'disabled', 'href', 'items', 'length', 'loadingText', 'loadingType', 'page', 'routerDirection', 'spinner', 'statusText', 'toolbar'],
  methods: ['complete']
})
@Component({
  selector: 'bkkr-paginator',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['animated', 'arrowIcon', 'changeLength', 'disabled', 'href', 'items', 'length', 'loadingText', 'loadingType', 'page', 'routerDirection', 'spinner', 'statusText', 'toolbar']
})
export class BkkrPaginator {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['bkkrPaginator', 'bkkrPageSizeChanged']);
  }
}


export declare interface BkkrProgressBar extends Components.BkkrProgressBar {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['buffer', 'color', 'reversed', 'type', 'value']
})
@Component({
  selector: 'bkkr-progress-bar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['buffer', 'color', 'reversed', 'type', 'value']
})
export class BkkrProgressBar {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface BkkrRadio extends Components.BkkrRadio {
  /**
   * Emitted when the radio button has focus. 
   */
  bkkrFocus: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the radio button loses focus. 
   */
  bkkrBlur: EventEmitter<CustomEvent<void>>;

}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['color', 'disabled', 'name', 'value']
})
@Component({
  selector: 'bkkr-radio',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['color', 'disabled', 'name', 'value']
})
export class BkkrRadio {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['bkkrFocus', 'bkkrBlur']);
  }
}

import type { RadioGroupChangeEventDetail as IRadioGroupRadioGroupChangeEventDetail } from '@bkkr/core';
export declare interface BkkrRadioGroup extends Components.BkkrRadioGroup {
  /**
   * Emitted when the value has changed. 
   */
  bkkrChange: EventEmitter<CustomEvent<IRadioGroupRadioGroupChangeEventDetail>>;

}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['allowEmptySelection', 'name', 'value']
})
@Component({
  selector: 'bkkr-radio-group',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['allowEmptySelection', 'name', 'value']
})
export class BkkrRadioGroup {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['bkkrChange']);
  }
}

import type { RangeChangeEventDetail as IRangeRangeChangeEventDetail } from '@bkkr/core';
import type { RangeKnobMoveStartEventDetail as IRangeRangeKnobMoveStartEventDetail } from '@bkkr/core';
import type { RangeKnobMoveEndEventDetail as IRangeRangeKnobMoveEndEventDetail } from '@bkkr/core';
export declare interface BkkrRange extends Components.BkkrRange {
  /**
   * Emitted when the value property has changed. 
   */
  bkkrChange: EventEmitter<CustomEvent<IRangeRangeChangeEventDetail>>;
  /**
   * Emitted when the range has focus. 
   */
  bkkrFocus: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the range loses focus. 
   */
  bkkrBlur: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the user starts moving the range knob, whether through
mouse drag, touch gesture, or keyboard interaction. 
   */
  bkkrKnobMoveStart: EventEmitter<CustomEvent<IRangeRangeKnobMoveStartEventDetail>>;
  /**
   * Emitted when the user finishes moving the range knob, whether through
mouse drag, touch gesture, or keyboard interaction. 
   */
  bkkrKnobMoveEnd: EventEmitter<CustomEvent<IRangeRangeKnobMoveEndEventDetail>>;

}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['activeBarStart', 'color', 'debounce', 'disabled', 'dualKnobs', 'max', 'min', 'name', 'pin', 'pinFormatter', 'snaps', 'step', 'ticks', 'value']
})
@Component({
  selector: 'bkkr-range',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['activeBarStart', 'color', 'debounce', 'disabled', 'dualKnobs', 'max', 'min', 'name', 'pin', 'pinFormatter', 'snaps', 'step', 'ticks', 'value']
})
export class BkkrRange {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['bkkrChange', 'bkkrFocus', 'bkkrBlur', 'bkkrKnobMoveStart', 'bkkrKnobMoveEnd']);
  }
}


export declare interface BkkrReorder extends Components.BkkrReorder {}

@ProxyCmp({
  defineCustomElementFn: undefined
})
@Component({
  selector: 'bkkr-reorder',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>'
})
export class BkkrReorder {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}

import type { ItemReorderEventDetail as IReorderGroupItemReorderEventDetail } from '@bkkr/core';
export declare interface BkkrReorderGroup extends Components.BkkrReorderGroup {
  /**
   * Event that needs to be listened to in order to complete the reorder action.
Once the event has been emitted, the `complete()` method then needs
to be called in order to finalize the reorder action. 
   */
  bkkrItemReorder: EventEmitter<CustomEvent<IReorderGroupItemReorderEventDetail>>;

}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['disabled'],
  methods: ['complete']
})
@Component({
  selector: 'bkkr-reorder-group',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['disabled']
})
export class BkkrReorderGroup {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['bkkrItemReorder']);
  }
}


export declare interface BkkrRoot extends Components.BkkrRoot {}

@ProxyCmp({
  defineCustomElementFn: undefined
})
@Component({
  selector: 'bkkr-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>'
})
export class BkkrRoot {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface BkkrRow extends Components.BkkrRow {}

@ProxyCmp({
  defineCustomElementFn: undefined
})
@Component({
  selector: 'bkkr-row',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>'
})
export class BkkrRow {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}

import type { SearchbarChangeEventDetail as ISearchbarSearchbarChangeEventDetail } from '@bkkr/core';
export declare interface BkkrSearchbar extends Components.BkkrSearchbar {
  /**
   * Emitted when a keyboard input occurred. 
   */
  bkkrInput: EventEmitter<CustomEvent<KeyboardEvent>>;
  /**
   * Emitted when the value has changed. 
   */
  bkkrChange: EventEmitter<CustomEvent<ISearchbarSearchbarChangeEventDetail>>;
  /**
   * Emitted when the cancel button is clicked. 
   */
  bkkrCancel: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the clear input button is clicked. 
   */
  bkkrClear: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the input loses focus. 
   */
  bkkrBlur: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the input has focus. 
   */
  bkkrFocus: EventEmitter<CustomEvent<void>>;

}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['animated', 'autocomplete', 'autocorrect', 'cancelButtonText', 'color', 'debounce', 'disabled', 'enterkeyhint', 'inputmode', 'placeholder', 'searchIcon', 'showCancelButton', 'spellcheck', 'type', 'value'],
  methods: ['setFocus', 'getInputElement']
})
@Component({
  selector: 'bkkr-searchbar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['animated', 'autocomplete', 'autocorrect', 'cancelButtonText', 'color', 'debounce', 'disabled', 'enterkeyhint', 'inputmode', 'placeholder', 'searchIcon', 'showCancelButton', 'spellcheck', 'type', 'value']
})
export class BkkrSearchbar {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['bkkrInput', 'bkkrChange', 'bkkrCancel', 'bkkrClear', 'bkkrBlur', 'bkkrFocus']);
  }
}

import type { SegmentChangeEventDetail as ISegmentSegmentChangeEventDetail } from '@bkkr/core';
export declare interface BkkrSegment extends Components.BkkrSegment {
  /**
   * Emitted when the value property has changed and any
dragging pointer has been released from `bkkr-segment`. 
   */
  bkkrChange: EventEmitter<CustomEvent<ISegmentSegmentChangeEventDetail>>;

}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['color', 'disabled', 'scrollable', 'selectOnFocus', 'swipeGesture', 'value']
})
@Component({
  selector: 'bkkr-segment',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['color', 'disabled', 'scrollable', 'selectOnFocus', 'swipeGesture', 'value']
})
export class BkkrSegment {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['bkkrChange']);
  }
}


export declare interface BkkrSegmentButton extends Components.BkkrSegmentButton {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['disabled', 'type', 'value']
})
@Component({
  selector: 'bkkr-segment-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['disabled', 'type', 'value']
})
export class BkkrSegmentButton {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}

import type { SelectChangeEventDetail as ISelectSelectChangeEventDetail } from '@bkkr/core';
export declare interface BkkrSelect extends Components.BkkrSelect {
  /**
   * Emitted when the user types in a searchbar. 
   */
  bkkrSearch: EventEmitter<CustomEvent<ISelectSelectChangeEventDetail>>;
  /**
   * Emitted when the value has changed. 
   */
  bkkrChange: EventEmitter<CustomEvent<ISelectSelectChangeEventDetail>>;
  /**
   * Emitted when the selection is opened. 
   */
  bkkrOpen: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the selection is cancelled. 
   */
  bkkrCancel: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the overlay is dismissed. 
   */
  bkkrDismiss: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the select has focus. 
   */
  bkkrFocus: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the select loses focus. 
   */
  bkkrBlur: EventEmitter<CustomEvent<void>>;

}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['cancelText', 'compareWith', 'deselect', 'disabled', 'interface', 'interfaceOptions', 'multiple', 'name', 'okText', 'placeholder', 'search', 'selectedText', 'spinner', 'toggleIcon', 'value'],
  methods: ['open']
})
@Component({
  selector: 'bkkr-select',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['cancelText', 'compareWith', 'deselect', 'disabled', 'interface', 'interfaceOptions', 'multiple', 'name', 'okText', 'placeholder', 'search', 'selectedText', 'spinner', 'toggleIcon', 'value']
})
export class BkkrSelect {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['bkkrSearch', 'bkkrChange', 'bkkrOpen', 'bkkrCancel', 'bkkrDismiss', 'bkkrFocus', 'bkkrBlur']);
  }
}


export declare interface BkkrSelectOption extends Components.BkkrSelectOption {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['disabled', 'value']
})
@Component({
  selector: 'bkkr-select-option',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['disabled', 'value']
})
export class BkkrSelectOption {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface BkkrShape extends Components.BkkrShape {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['color', 'shape', 'size', 'sizeLg', 'sizeMd', 'sizeSm', 'sizeXl', 'sizeXs', 'sizeXxl']
})
@Component({
  selector: 'bkkr-shape',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['color', 'shape', 'size', 'sizeLg', 'sizeMd', 'sizeSm', 'sizeXl', 'sizeXs', 'sizeXxl']
})
export class BkkrShape {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface BkkrSkeleton extends Components.BkkrSkeleton {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['animated']
})
@Component({
  selector: 'bkkr-skeleton',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['animated']
})
export class BkkrSkeleton {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface BkkrSlide extends Components.BkkrSlide {}

@ProxyCmp({
  defineCustomElementFn: undefined
})
@Component({
  selector: 'bkkr-slide',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>'
})
export class BkkrSlide {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface BkkrSlides extends Components.BkkrSlides {
  /**
   * Emitted after Swiper initialization 
   */
  bkkrSlidesDidLoad: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the user taps/clicks on the slide's container. 
   */
  bkkrSlideTap: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the user double taps on the slide's container. 
   */
  bkkrSlideDoubleTap: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted before the active slide has changed. 
   */
  bkkrSlideWillChange: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted after the active slide has changed. 
   */
  bkkrSlideDidChange: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the next slide has started. 
   */
  bkkrSlideNextStart: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the previous slide has started. 
   */
  bkkrSlidePrevStart: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the next slide has ended. 
   */
  bkkrSlideNextEnd: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the previous slide has ended. 
   */
  bkkrSlidePrevEnd: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the slide transition has started. 
   */
  bkkrSlideTransitionStart: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the slide transition has ended. 
   */
  bkkrSlideTransitionEnd: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the slider is actively being moved. 
   */
  bkkrSlideDrag: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the slider is at its initial position. 
   */
  bkkrSlideReachStart: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the slider is at the last slide. 
   */
  bkkrSlideReachEnd: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the user first touches the slider. 
   */
  bkkrSlideTouchStart: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the user releases the touch. 
   */
  bkkrSlideTouchEnd: EventEmitter<CustomEvent<void>>;

}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['options', 'pager', 'scrollbar'],
  methods: ['update', 'updateAutoHeight', 'slideTo', 'slideNext', 'slidePrev', 'getActiveIndex', 'getPreviousIndex', 'length', 'isEnd', 'isBeginning', 'startAutoplay', 'stopAutoplay', 'lockSwipeToNext', 'lockSwipeToPrev', 'lockSwipes', 'getSwiper']
})
@Component({
  selector: 'bkkr-slides',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['options', 'pager', 'scrollbar']
})
export class BkkrSlides {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['bkkrSlidesDidLoad', 'bkkrSlideTap', 'bkkrSlideDoubleTap', 'bkkrSlideWillChange', 'bkkrSlideDidChange', 'bkkrSlideNextStart', 'bkkrSlidePrevStart', 'bkkrSlideNextEnd', 'bkkrSlidePrevEnd', 'bkkrSlideTransitionStart', 'bkkrSlideTransitionEnd', 'bkkrSlideDrag', 'bkkrSlideReachStart', 'bkkrSlideReachEnd', 'bkkrSlideTouchStart', 'bkkrSlideTouchEnd']);
  }
}


export declare interface BkkrSpinner extends Components.BkkrSpinner {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['color', 'duration', 'paused', 'type']
})
@Component({
  selector: 'bkkr-spinner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['color', 'duration', 'paused', 'type']
})
export class BkkrSpinner {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface BkkrSplitPane extends Components.BkkrSplitPane {
  /**
   * Expression to be called when the split-pane visibility has changed 
   */
  bkkrSplitPaneVisible: EventEmitter<CustomEvent<{ visible: boolean }>>;

}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['contentId', 'disabled', 'when']
})
@Component({
  selector: 'bkkr-split-pane',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['contentId', 'disabled', 'when']
})
export class BkkrSplitPane {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['bkkrSplitPaneVisible']);
  }
}

import type { TextareaChangeEventDetail as ITextareaTextareaChangeEventDetail } from '@bkkr/core';
export declare interface BkkrTextarea extends Components.BkkrTextarea {
  /**
   * Emitted when the input value has changed. 
   */
  bkkrChange: EventEmitter<CustomEvent<ITextareaTextareaChangeEventDetail>>;
  /**
   * Emitted when a keyboard input occurred. 
   */
  bkkrInput: EventEmitter<CustomEvent<InputEvent>>;
  /**
   * Emitted when the input loses focus. 
   */
  bkkrBlur: EventEmitter<CustomEvent<FocusEvent>>;
  /**
   * Emitted when the input has focus. 
   */
  bkkrFocus: EventEmitter<CustomEvent<FocusEvent>>;

}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['autoGrow', 'autocapitalize', 'autofocus', 'clearOnEdit', 'color', 'cols', 'debounce', 'disabled', 'enterkeyhint', 'inputmode', 'maxlength', 'minlength', 'name', 'placeholder', 'readonly', 'required', 'rows', 'spellcheck', 'value', 'wrap'],
  methods: ['setFocus', 'getInputElement']
})
@Component({
  selector: 'bkkr-textarea',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['autoGrow', 'autocapitalize', 'autofocus', 'clearOnEdit', 'color', 'cols', 'debounce', 'disabled', 'enterkeyhint', 'inputmode', 'maxlength', 'minlength', 'name', 'placeholder', 'readonly', 'required', 'rows', 'spellcheck', 'value', 'wrap']
})
export class BkkrTextarea {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['bkkrChange', 'bkkrInput', 'bkkrBlur', 'bkkrFocus']);
  }
}


export declare interface BkkrThumbnail extends Components.BkkrThumbnail {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['disabled']
})
@Component({
  selector: 'bkkr-thumbnail',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['disabled']
})
export class BkkrThumbnail {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}

import type { ToggleChangeEventDetail as IToggleToggleChangeEventDetail } from '@bkkr/core';
export declare interface BkkrToggle extends Components.BkkrToggle {
  /**
   * Emitted when the value property has changed. 
   */
  bkkrChange: EventEmitter<CustomEvent<IToggleToggleChangeEventDetail>>;
  /**
   * Emitted when the toggle has focus. 
   */
  bkkrFocus: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the toggle loses focus. 
   */
  bkkrBlur: EventEmitter<CustomEvent<void>>;

}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['checked', 'color', 'disabled', 'enableOnOffLabels', 'name', 'value']
})
@Component({
  selector: 'bkkr-toggle',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['checked', 'color', 'disabled', 'enableOnOffLabels', 'name', 'value']
})
export class BkkrToggle {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['bkkrChange', 'bkkrFocus', 'bkkrBlur']);
  }
}


export declare interface BkkrToolbar extends Components.BkkrToolbar {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['color']
})
@Component({
  selector: 'bkkr-toolbar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['color']
})
export class BkkrToolbar {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}
